import React, { useState } from 'react';
import { Button } from 'antd';
import { Role2 } from '../../../models';
import { RolePermissionsList } from './role-permissions-list';

interface RolePermissionsSummaryProps {
  role: Role2;
  maxDisplay?: number;
}

export function RolePermissionsSummary({ role, maxDisplay = 10 }: RolePermissionsSummaryProps) {
  const [permissionsModalOpen, setPermissionsModalOpen] = useState(false);

  const openPermissionsModal = () => {
    setPermissionsModalOpen(true);
  };

  const closePermissionsModal = () => {
    setPermissionsModalOpen(false);
  };

  const permissions = role.permissions2;

  if (!permissions || permissions.length === 0) {
    return <>-</>;
  }

  // Permissions are already sorted by the backend based on permission targets order
  const displayPermissions = permissions.slice(0, maxDisplay);
  // Use permissions2Count from role if available, otherwise calculate from current array
  const totalPermissionsCount = role.permissions2Count !== undefined ? role.permissions2Count : permissions.length;
  const remainingCount = Math.max(0, totalPermissionsCount - maxDisplay);

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
        {displayPermissions.map((permission, index) => {
          const isAllow = permission.effect === 'ALLOW';
          const filterLabel = permission.filterGroupDetails?.filterLabels?.join(permission.filterGroupDetails?.logic === 'AND' ? ' VE ' : ' VEYA ');

          return (
            <div key={index} style={{ fontSize: '12px', lineHeight: '1.4', display: 'flex', alignItems: 'center', gap: '4px' }}>
              <span>•</span>
              <span style={{ color: isAllow ? '#52c41a' : '#ff4d4f', fontWeight: 'bold', fontSize: '14px' }}>{isAllow ? '✓' : '✕'}</span>
              <span>{permission.targetLabel || permission.target}</span>
              {filterLabel && <span style={{ fontSize: '11px', color: '#999' }}>(Filtre: {filterLabel})</span>}
            </div>
          );
        })}
        {remainingCount > 0 && (
          <div style={{ fontSize: '12px', lineHeight: '1.4' }}>
            •{' '}
            <Button
              type="link"
              size="small"
              onClick={openPermissionsModal}
              style={{ padding: 0, height: 'auto', fontSize: '12px', lineHeight: '1.4' }}
            >
              {remainingCount} yetki daha...
            </Button>
          </div>
        )}
      </div>

      <RolePermissionsList
        role={role}
        visible={permissionsModalOpen}
        onClose={closePermissionsModal}
      />
    </>
  );
}
